import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { Fab, Grid, Theme, useMediaQuery } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import { PermissionArea } from '@pbt/pbt-ui-components'

import DialogNames from '~/constants/DialogNames'
import FeatureToggle from '~/constants/featureToggle'
import { getCRUDByArea } from '~/store/reducers/auth'
import { getFeatureToggle } from '~/store/reducers/constants'
import { addSearch } from '~/utils'
import useDialog from '~/utils/useDialog'

import DocumentDetails from './DocumentDetails'
import DocumentsTableComponent from './DocumentsTableComponent'
import DocumentsTableComponentNew from './DocumentsTableComponentNew'

const useStyles = makeStyles(
  () => ({
    button: {
      minWidth: 120,
      height: 40,
    },
  }),
  { name: 'DocumentsPage' },
)

const DocumentsPage = () => {
  const navigate = useNavigate()
  const { documentId } = useParams()
  const location = useLocation()
  const classes = useStyles()
  const permissions = useSelector(getCRUDByArea(PermissionArea.FORM))
  const isMobile = useMediaQuery<Theme>((theme) => theme.breakpoints.down('md'))
  const { t } = useTranslation('Common')

  const isInputFormsEnabled = useSelector(
    getFeatureToggle(FeatureToggle.INPUT_FORMS_DOCUMENT),
  )

  const [openNewDocumentDialog] = useDialog(DialogNames.DOCUMENT)

  const onDetailsClose = () => {
    navigate(addSearch(location, '/admin/catalog/documents'))
  }

  if (isMobile && typeof documentId !== 'undefined') {
    return <DocumentDetails itemId={documentId} onClose={onDetailsClose} />
  }

  const headerButtons = (
    <Grid container item justifyContent="flex-end" px={3} py={2}>
      <Fab
        className={classes.button}
        color="inherit"
        variant="extended"
        onClick={() =>
          openNewDocumentDialog({
            PreviewProps: {
              hideEmail: true,
              hidePrint: true,
            },
          })
        }
      >
        {t('Common:ADD_NEW')}
      </Fab>
    </Grid>
  )

  const Component = isInputFormsEnabled
    ? DocumentsTableComponentNew
    : DocumentsTableComponent

  return (
    <Grid container item flex={1} wrap="nowrap">
      <Component
        documentId={documentId}
        headerButtons={permissions.create && headerButtons}
        onDetailsClose={onDetailsClose}
      />
    </Grid>
  )
}

export default DocumentsPage
